import * as angular from "angular";
import {applyMiddleware, createStore, compose} from "redux";
import {default as reducers} from "../reducers";
import thunk from "redux-thunk";
import * as React from "react";
import {connect, Provider} from "react-redux";
import server from "../../../../integration/server/server-services";
import nvdbapi from "../../../../integration/nvdbapi/nvdbapi";
import security from "../../../../service/security/security-services";
import * as selectors from "../selectors";
import {
    initDownload,
    InitDownload,
} from "../actions";
import DownloadState from "../DownloadState";
import datacatalog from "../../../../integration/datacatalog/datacatalog-services";
import {ObjectList} from "./ObjectList"
import {DestinationSelection} from "./DestinationSelection";
import {ProjectRefSelection} from "./ProjectRefSelection";
import {OperationSelection} from "./OperationSelection";
import {SridSelection} from "./SridSelection";
import {DownloadButton} from "./DownloadButton";
import {FeaturesByType} from "../../../../integration/representation/feature";
import {featuresByTypeAndDestination, selectedFeatureTypeIds} from "../selectors";
import {fetchingFeatures} from "../../contract-eventlog/selectors";

export class ServerHolder {
    constructor(
        public security: security = null,
        public server: server = null,
        public scope: angular.IRootScopeService = null,
        public nvdbapi: nvdbapi = null,
        public datacatalog: datacatalog = null,
        public $q: angular.IQService = null,
        public contractId: string = null,
    ) {
    }
}

const serverHolder = new ServerHolder();
declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    }
}
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, /* preloadedState, */ composeEnhancers(
    applyMiddleware(thunk.withExtraArgument(serverHolder))
));
// const store = createStore(reducers, applyMiddleware(thunk.withExtraArgument(serverHolder)), window.devToolsExten && window.__REDUX_DEVTOOLS_EXTENSION__());

interface DownloadProps {
    server: server,
    security: security,
    nvdbapi: nvdbapi,
    datacatalog: datacatalog,
    $q: angular.IQService,
    $routeParams: angular.route.IRouteParamsService,
    $rootScope: angular.IRootScopeService
}

interface StateProps {
    loadingFeatures: boolean,
    loadingContract: boolean,
    contractId: string,
}

interface DispatchProps {
    doInitDownload: InitDownload,
}

interface TagProps {
}

interface localState {
    isLoggedIn: boolean,
}

type Props = DispatchProps & StateProps & TagProps;

class DownloadView extends React.Component<Props, localState> {
    componentWillMount() {
        let {contractId} = this.props;
        this.props.doInitDownload(contractId);
    }

    render() {
        const { loadingFeatures, loadingContract } = this.props;

        return loadingContract ? <>
            <div className="cssloader loading-spinner" ng-show="conCtrl.contract.loading.contract"></div>
            <div className="loading-text">
                Henter kontrakt...
            </div>
        </> : (
            <>
                <div className="container">
                    <h1>Last ned SOSI</h1>
                    <div className="section">
                    <div className={"download-feature-types"}>
                            <div className="content">
                                <h2>Velg objekttyper</h2>
                            </div>
                            <div className="scrollable-content content">
                                {loadingFeatures ? <h3 className={"color-mid-gray"}>Laster ...</h3> : <ObjectList/>}
                            </div>
                        </div>
                        <div className={"download-selections-column"}>
                            <div className={"download-selection-options"}>
                                <DestinationSelection />
                                <OperationSelection />
                                <ProjectRefSelection />
                                <SridSelection />
                            </div>
                            <DownloadButton />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}


export class DownloadMain extends React.Component<DownloadProps, {isLoggedIn: boolean}> {

    constructor(props: DownloadProps) {
        super(props);
        this.state = {
            isLoggedIn: false
        }
    }

    componentWillMount() {
        this.props.security.ensureCurrentUser().then(result => {
            this.setState(
                {
                    isLoggedIn: true,
                })
        })
    }

    render() {
        const mapStateToProps = (state: DownloadState): StateProps => {
            const contractId = this.props.$routeParams["contractId"];
            return {
                loadingFeatures: state.loadingFeatures,
                loadingContract: state.loadingContract,
                contractId: contractId,
            }
        };

        const mapDispatchToProps: DispatchProps = ({
            doInitDownload: initDownload,
        });

        serverHolder.security = this.props.security;
        serverHolder.server = this.props.server;
        serverHolder.nvdbapi = this.props.nvdbapi;
        serverHolder.datacatalog = this.props.datacatalog;
        serverHolder.$q = this.props.$q;
        serverHolder.contractId = this.props.$routeParams["contractId"];
        serverHolder.scope = this.props.$rootScope;

        const DownloadComponent = connect(mapStateToProps, mapDispatchToProps)(DownloadView);

        // prevent mounting DownloadComponent if the user is not logged in.
        // this keeps the login-window clean and we ensure that the user is logged in before we query the API on mount.
        if (!this.state.isLoggedIn) {
            return null;
        }

        return (
            <Provider store={store} key="provider">
                <DownloadComponent/>
            </Provider>
        )
    }
}

